import axios from '../utils/axios';

export default function getAllTagsCount(adminId, params) {
    return axios.get(`/admin/${adminId}/get-all-tags-count`, { params });
};